<div
  class="tab-pane engine__tab-pane fade show active"
  id="buses"
  role="tabpanel"
  aria-labelledby="buses-tab"
>
  <div class="search-from" name="bus">
    <div class="search-form__engine">
      <div
        class="search-form__guests search-form__select search-form__element p-0"
      >
        <app-engine-control-guests
          (click)="onInputSelection()"
        ></app-engine-control-guests>
      </div>

      <div class="search-form__select search-form__element">
        <div class="form-group-custom">
          <label for="inputDestinationTour" class="input-group-zeus__label"
            >Destinazione</label
          >
          <div
            class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
            id="holidayDestination-dropdown"
          >
            <input
              type="text"
              class="form-control-custom"
              id="inputDestinationTour"
              [placeholder]="
                selectedDestination?.name
                  ? selectedDestination?.name
                  : 'Seleziona la destinazione...'
              "
              aria-label="Destinazione"
              aria-describedby="basic-addon3"
              (click)="openModal(content)"
              readonly
            />
            <div
              class="input-group-custom__prepend input-group-custom__prepend--transparent"
            >
              <span
                class="input-group-custom__icon input-group-custom__icon--transparent"
                id="basic-addon3"
                ><i class="icon-pin"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="search-form__select search-form__element">
        <div class="form-group-custom">
          <label for="inputBusDate" class="input-group-zeus__label">Data</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="busDate-select">
            <ng-select [items]="dates"
                      [disabled]="!selectedDestination"
                      [loading]="selectedDestination?.id && !dates"
                      placeholder="Seleziona la data"
                      bindLabel="dateLabel"
                      bindValue="dateValue"

                      (change)="selectDate($event)"
                      id = "inputBusDate"
                      class="form-control-custom"
                      [(ngModel)]="selectedDate">
            </ng-select>
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-date"></i></span>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="search-form__calendar search-form__element"
        [ngClass]="{ disabled: !selectedDestination?.id }"
      >
        <div class="form-group-custom">
          <label for="inputCalendarHoliday" class="input-group-zeus__label"
            >Data</label
          >
          <div
            class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
            id="inputCalendarHoliday-dropdown"
          >
            <input
              type="text"
              class="form-control-custom"
              id="inputCalendarHoliday"
              [placeholder]="
                selectedDate
                  ? (selectedDate | date : 'dd MMM YYYY' : null : 'it')
                  : 'Seleziona data'
              "
              aria-label="Data"
              aria-describedby="basic-addon3"
              (click)="open()"
              readonly
            />
            <div
              class="input-group-custom__prepend input-group-custom__prepend--transparent"
            >
              <span
                class="input-group-custom__icon input-group-custom__icon--transparent"
                id="basic-addon2"
                ><i class="icon-calendar"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
      <button
        [disabled]="!selectedDestination || !selectedDate"
        (click)="searchBuses()"
        class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3"
      >
        Cerca <i class="icon-search"></i>
      </button>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <app-element-loader
    [loadingMessage]="loadingMessage"
    [loadingStatus]="loadingStatus"
  ></app-element-loader>
  <div class="modal-header modal-custom__header modal__destinations-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="icon-pin"></i> Dove vuoi andare?
    </h4>
    <button
      #close
      type="button"
      class="close modal-close"
      aria-label="close"
      (click)="modal.dismiss()"
    >
      <span aria-hidden="true">Chiudi <i class="icon-close"></i></span>
    </button>
  </div>
  <div class="modal-body modal-custom__body modal__destinations-body">
    <div class="destinations-thumbnail" *ngIf="!(isMobile$ | async)">
      <app-holiday-destinations-slider
        (selectedDestination)="onSelectedDestination($event)"
        [destinationBox$]="destinationBox$"
      ></app-holiday-destinations-slider>
    </div>
    <div class="destinations-thumbnail" *ngIf="isMobile$ | async">
      <app-holiday-destinations-list
        (selectedDestination)="onSelectedDestination($event)"
        [destinationBox$]="destinationBox$"
      ></app-holiday-destinations-list>
    </div>
  </div>
  <div
    class="modal-footer modal-custom__footer modal__destinations-footer destinations-thumbnail__bottom"
  >
    <div class="destinations-thumbnail__search">
      <div class="form-group-custom">
        <label for="inputSearchDestination" class="input-group-custom__label"
          >Cerca la destinazione</label
        >
        <div
          class="input-group-custom input-group-custom--icon-append input-group-custom--icon-append--transparent"
        >
          <input
            type="text"
            class="form-control-custom"
            id="inputSearchDestination"
            placeholder="Inserisci almeno 3 caratteri..."
            name="freeSearch"
            [(ngModel)]="selectedDestination"
            [resultFormatter]="destinationFormatter"
            [inputFormatter]="destinationFormatter"
            [editable]="false"
            (selectItem)="destinationChangeCB($event)"
            [ngbTypeahead]="destinationSearch.bind(this)"
          />
          <span [hidden]="!typeaheadLoading" class="spinner-border"></span>
          <div
            class="input-group-custom__append input-group-custom__append--transparent"
            *ngIf="selectedDestination"
            (click)="destinationClearCB()"
          >
            <span
              class="input-group-custom__icon input-group-custom__icon--transparent"
              ><i class="g-icon-close"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
